import AgeVerificationReducer from "@common/redux/reducers/AgeVerificationReducer";
import BaseAction from "@common/redux/actions/BaseAction";

class AgeVerificationAction extends BaseAction {}

const action = new AgeVerificationAction(AgeVerificationReducer);

export default action;
